import { useState, useEffect } from "react";
import { Section } from "../../store/section-store";

interface NiceTimeDisplayProps {
  currentSection?: string;
}

export default function NiceTimeDisplay({
  currentSection,
}: NiceTimeDisplayProps) {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  // Format time in French style: DD/MM/YYYY HH:MM:SS
  const formatTime = (date: Date) => {
    // Convert to Nice timezone (Europe/Paris)
    const niceTime = new Date(
      date.toLocaleString("en-US", { timeZone: "Europe/Paris" })
    );

    // Convert to Seoul timezone (Asia/Seoul)
    const seoulTime = new Date(
      date.toLocaleString("en-US", { timeZone: "Asia/Seoul" })
    );

    const formatTimeString = (time: Date) => {
      const day = time.getDate().toString().padStart(2, "0");
      const month = (time.getMonth() + 1).toString().padStart(2, "0");
      const year = time.getFullYear();
      const hours = time.getHours().toString().padStart(2, "0");
      const minutes = time.getMinutes().toString().padStart(2, "0");
      const seconds = time.getSeconds().toString().padStart(2, "0");
      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    };

    const niceTimeStr = formatTimeString(niceTime);
    const seoulTimeStr = formatTimeString(seoulTime);

    return (
      <>
        <span style={{ fontWeight: "600" }}>NICE:</span>
        {niceTimeStr}
        <span style={{ margin: "0 100px" }}>|</span>
        <span style={{ fontWeight: "600" }}>SEOUL:</span>
        {seoulTimeStr}
      </>
    );
  };

  // Get styling based on current section
  const getSectionStyling = () => {
    switch (currentSection) {
      case Section.Menu:
        return {
          color: "black",
          textShadow: "0 0 4px white, 0 0 8px white, 0 0 12px white",
          backdropFilter: "blur(2px)",
        };
      case Section.Footer:
        return {
          color: "white",
        };
      default:
        return {
          color: "inherit",
        };
    }
  };

  return (
    <div
      style={{
        position: "absolute",
        top: "0",
        left: "0",
        right: "0",
        bottom: "0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transform: "rotate(-90deg)",
        fontSize: "10px",
        fontWeight: "400",
        whiteSpace: "nowrap",
        pointerEvents: "none",
        letterSpacing: "0.5px",
        ...getSectionStyling(),
      }}
    >
      {formatTime(currentTime)}
    </div>
  );
}
